const SignUpRegistrationInitiated = ({ email }) => {
    return (
      <div className='flex flex-col items-center justify-center p-6 bg-gray-50 shadow-md rounded-lg'>
        <h3 className='text-xl font-bold text-indigo-700'>
          Registration Initiated Successfully!
        </h3>
        <p className='text-gray-700 text-center mt-3'>
          Your registration process has started. To gain access, please contact the admin for further verification.
        </p>
        <p className='mt-2 text-gray-600 text-center'>
          Ensure to provide your registered email: <strong className='text-indigo-600'>{email}</strong>
        </p>
      </div>
    );
  };  
  
  export default SignUpRegistrationInitiated;
  